export default __webpack_public_path__ + "static/media/s_instagram_l.61879827.svg";